import { memo, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
// Import UI components
import { Icon, Tooltip } from '@geneui/components';
// Import Hooks
import useGoToRoute from 'hooks/GoToRoute';

const NavigationItemCircle = ({ clickHandler, iconClass, displayNameKey, route }) => {
    const { getRoutePath } = useGoToRoute();

    const [isEllipsisActive, setIsEllipsisActive] = useState(false);

    const textRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if ((textRef?.current?.offsetWidth ?? 0) < (textRef?.current?.scrollWidth ?? 0)) {
            setIsEllipsisActive(true);
        }
    }, [displayNameKey]);

    const path = useMemo(() => {
        if (route) {
            return getRoutePath(route);
        }
    }, [getRoutePath, route]);

    const content = route ? (
        <a href={path} onClick={clickHandler} className="crm-menu-item-circle">
            <Icon className={`${iconClass}`} />
            <span ref={textRef}>{displayNameKey}</span>
        </a>
    ) : (
        <button onClick={clickHandler} className="crm-menu-item-circle">
            <Icon className={`${iconClass}`} />
            <span ref={textRef}>{displayNameKey}</span>
        </button>
    );

    return (
        <>
            {isEllipsisActive ? (
                <Tooltip text={displayNameKey} position="bottom">
                    {content}
                </Tooltip>
            ) : (
                <>{content}</>
            )}
        </>
    );
};

NavigationItemCircle.propTypes = {
    clickHandler: PropTypes.func,
    iconClass: PropTypes.string,
    displayNameKey: PropTypes.string,
    route: PropTypes.object,
};

export default memo(NavigationItemCircle);
